// extracted by mini-css-extract-plugin
module.exports = {"avScheduleItem":"_1bWYRd","avScheduleItemCol":"I0bJLQ","scheduleDateBadge":"_2iQF47","scheduleTimeBadge":"_3BPXA1","avScheduleList":"_393k_L"};